/*** IMPORTS FROM imports-loader ***/
var define = false;

import upIcon from '@SvgIcon/arrow-up-b.svg';

import $ from 'jquery';
import debounce from 'lodash/debounce';
import svgIconHtml from '../../../shared/svgIconHtml';

export default {
  template: `
    <transition name="fade">
      <button v-if="show" type="button" class="scroll-to-top" @click="scrollToTop" aria-label="Scroll to Top">
        ${svgIconHtml(upIcon)}
      </button>
    </transition>
  `,
  data() {
    return {
      show: false,
    };
  },
  methods: {
    scrollToTop() {
      $('html, body').animate({
        scrollTop: 0,
      }, 600);
    },
  },
  mounted() {
    this.$nextTick(() => {
      $(window).scroll(debounce(() => {
        this.show = $(window).scrollTop() > 200;
      }));
    });
  },
};

